module.exports = __webpack_public_path__ + "img/bg-home-up-recuperi.d51429ae.png";